<template>
  <div>
    <v-dialog
      v-model="infosDialog"
      max-width="320"
    >
      <v-card>
        <v-card-title class="headline">{{titleDialog}}</v-card-title>

        <v-card-text>
          {{contentDialog}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="fermeDialog()"
          >
           {{$t('close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      infosDialog: false
    }
  },
  props: ['openDialogInfos', 'titleDialog', 'contentDialog'],
  created () {
  },

  methods: {
    // ----------------------------------------------------------------------------
    // open la dialogBox
    // ----------------------------------------------------------------------------
    openDialog () {
      this.infosDialog = true
      // this.titleDialog = data.title
      // this.contentDialog = data.content
    },
    // ----------------------------------------------------------------------------
    // close la dialogBox
    // ----------------------------------------------------------------------------
    fermeDialog () {
      // ferme le chat
      this.infosDialog = false
      this.$emit('fermeDialog')
    }
  },

  computed: {
  },

  watch: {
    titleDialog: function (v) {
      console.log('v', v)
      if (v) {
        this.openDialog()
        // this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzDialogInfos.vue